export default __webpack_public_path__ + "./assets/img/reasons-2-7094be80153cc00b96f1fd9abd652910.png";